import { AzureKeyVault, IAttribute, IModel, LinkedService, Metamodel } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';

@Metamodel.model({
    name: adfModelTypeMap.smartsheet.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Smartsheet_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Smartsheet_DisplayText)
    ]
})
export class SmartsheetLinkedService extends LinkedService {
    public static readonly MODEL: IModel;
    public static API_TOKEN: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_Token,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        templatable: true,
        association: 'API_TOKEN',
        accepts: ['String']
    })
    public apiToken: string | AzureKeyVault;
}
